document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bc-compare]').forEach((root) => {
    const range = root.querySelector('[data-bc-compare-range]');
    const after = root.querySelector('[data-bc-compare-after]');
    const handle = root.querySelector('[data-bc-compare-handle]');
    if (!range || !after || !handle) return;

    const update = (value) => {
      after.style.clipPath = `inset(0 0 0 ${value}%)`;
      handle.style.left = `${value}%`;
    };

    range.addEventListener('input', (event) => {
      update(event.target.value);
    });

    update(range.value);
  });
});
